import { ProtectedRoute } from "@app/protected-route";
import type { ApplicationSearchParams } from "@entities/applications/applications";
import { Applications } from "@pages/applications/applications";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/applications/")({
	component: RouteComponent,
	validateSearch: (search: ApplicationSearchParams) => {
		return {
			search: search.search || "",
			startDate: search.startDate || "",
			endDate: search.endDate || "",
			page: search.page || 1,
			filterStatus: search.filterStatus || "",
			filters: search.filters || {},
			tab: search.tab || "single",
		};
	},
});

function RouteComponent() {
	return (
		<ProtectedRoute
			requiredPermissions={[
				"see_all_logs",
				"create_and_score_application",
				"read_results",
			]}
		>
			<Applications />
		</ProtectedRoute>
	);
}
